import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.PAGE,
    name: 'hiro',
    exclusiveRoutePath: '/hiro/:id',
    getComponent: () => import('./Hiro.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};
